import React, { useState, useEffect, useMemo } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   Box,
   Button,
   Flex,
   Text,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   Badge,
   Spinner,
   useColorModeValue,
   VStack,
   HStack,
   Icon,
   ModalFooter,
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   Divider,
   Checkbox,
   Alert,
   AlertIcon,
   AlertTitle,
   AlertDescription,
   Progress,
} from '@chakra-ui/react';
import { RefreshCw, Database, Wand2 } from 'lucide-react';
import {
   getAccountWithDupGstIN,
   getCgstNotEqualToSgst,
   getDupItem,
   getDupSerialNoINTran,
   getEmptySerialNo,
   getExtraLedger,
   getIssueDateLessThenPOrRDate,
   getLDWithOutCorresponingLIOrHeader,
   getOverAdju,
   getPRDateLessThenPDate,
   getPRRateNotSameWithPRate,
   getPWithPartyDatePartyBillNoDifference,
   getSameSerialNoWithDifferenetItem,
   getSDateLessThanPDate,
   getSerialNoSoldWithoutP,
   getSerialNoWithNegativeStock,
   getSerialNoWithStock,
   getSRDateLessThanSDate,
   getTranWithMissingAccount,
   getTranWithMissingItem,
   getTranWithMissingTransport,
   getTranWithSerialNoWithoutID,
   getWithoutLedger,
   getWrongSerialNoDueToLossOfInConn,
   getLINotEqualLD,
   getBalanceDifferenceInLedger,
   getIncompleteLedgerEntries,
   getDuplicateLedgerForSameAccount,
   getAutoEnhance,
} from '../../../redux/actions/CheckOs';
import { deleteLedgerEntries } from '../../../redux/actions/dashboard';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronDownIcon, InfoIcon } from '@chakra-ui/icons';
import { useUser, useGlobal } from '../../../contexts';
import { getItems } from '../../../redux/actions/item';
import { toast } from 'react-toastify';

const OSCheck = ({ isOpen, onClose }) => {
   const [activeTab, setActiveTab] = useState(null);
   const [subActiveTab, setSubActiveTab] = useState(null);
   const [loading, setLoading] = useState(false);
   const [data, setData] = useState(null);
   const [error, setError] = useState(null);
   const dispatch = useDispatch();
   const { user } = useUser();
   const [enhancing, setEnhancing] = useState(false);
   const [enhanceProgress, setEnhanceProgress] = useState(0);
   const [enhanceStatus, setEnhanceStatus] = useState(null);
   const bgGradient = useColorModeValue('linear(to-br, gray.50, gray.100)', 'linear(to-br, gray.800, gray.900)');
   const cardBg = useColorModeValue('white', 'gray.700');
   const borderColor = useColorModeValue('gray.200', 'gray.600');
   const hoverBg = useColorModeValue('gray.50', 'gray.600');
   const menuBg = useColorModeValue('white', 'gray.700');
   const border = useColorModeValue('gray.300', 'gray.600');
   const textColor = useColorModeValue('gray.700', 'gray.100');
   const hoverBorderColor = useColorModeValue('blue.400', 'blue.300');
   const activeBorderColor = useColorModeValue('blue.500', 'blue.300');
   const activeItemBg = useColorModeValue('blue.50', 'blue.900');
   const activeItemColor = useColorModeValue('blue.600', 'blue.300');
   const itemHoverBg = useColorModeValue('gray.50', 'gray.600');

   const { userGlobalSettingsData } = useGlobal();
   const isItem = useMemo(() => userGlobalSettingsData?.[0]?.askCompany?.item || false, [userGlobalSettingsData]);

   // Tab configuration with API endpoints
   const tabs = [
      { id: 1, label: 'Duplicate Accounts ( GSTIN )' },
      { id: 2, label: 'Blank SerialNo Entry' },
      { id: 3, label: 'CGST != SGST Entries' },
      { id: 4, label: 'Duplicate Items' },
      { id: 5, label: 'Duplicate Serial No In Same Transaction' },
      { id: 6, label: 'Extra Ledger' },
      { id: 7, label: 'Issue Date < Purchase / Receive Date' },
      { id: 8, label: 'Wrong serial no entry' },
      { id: 9, label: 'Purchase Return Date < Purchase Date' },
      { id: 10, label: 'Check Purchase (Date Difference)' },
      { id: 11, label: 'Purchase Return Rate != Purchase Rate' },
      { id: 12, label: 'Sales Date < Purchase Date' },
      { id: 13, label: 'Sales Return Date < Sales Date' },
      { id: 14, label: 'Same Serial No With Differenet Item' },
      { id: 15, label: 'Serial No Sold Without Purchase' },
      { id: 16, label: 'Serial No With Negative Stock' },
      { id: 17, label: 'Serial No With Over Stock' },
      { id: 18, label: 'Transactions Without Serial No.' },
      { id: 19, label: 'Check Missing Accounts' },
      { id: 20, label: 'Check Missing Items' },
      { id: 21, label: 'Check Missing Transports' },
      { id: 22, label: 'Transactions Without Ledger' },
      { id: 23, label: 'Wrong Serial No Due To Loss Of Interconnectivity' },
      { id: 24, label: 'Over Adjustment Record' },
      { id: 25, label: 'LineItem item != LineDetail item' },
      { id: 26, label: 'Balance Difference In Ledger' },
      { id: 27, label: 'Incomplete Ledger Entries' },
      { id: 28, label: 'Duplicate Ledger For Same Account' },
      { id: 29, label: 'Irrelevant Items' },
   ];

   const subTabs = [
      { id: 'SALES_WITHOUT_LEDGER', label: 'SALES' },
      { id: 'PURCHASE_WITHOUT_LEDGER', label: 'PURCHASE' },
      { id: 'SALES_RETURN_WITHOUT_LEDGER', label: 'SALES Return' },
      { id: 'PURCHASE_RETURN_WITHOUT_LEDGER', label: 'PURCHASE Return' },
      { id: 'VOUCHER_WITHOUT_LEDGER', label: 'VOUCHER' },
   ];

   const [filterOptions, setFilterOptions] = useState({
      notSeries: true,
      notColor: true,
      notCategory: true,
      notRam: true,
      notStorage: true,
   });

   const handleFilterChange = (key) => {
      setFilterOptions((prev) => ({
         ...prev,
         [key]: !prev[key],
      }));
   };

   const handleTabChange = async (tabId) => {
      console.log('tabId', tabId, typeof tabId);
      setActiveTab(tabId);
      setLoading(true);
      setEnhanceStatus(null);

      try {
         if (tabId === 1) {
            const res = await dispatch(getAccountWithDupGstIN());
            console.log('res', res);
            setData(res);
         }
         if (tabId === 2) {
            const res = await dispatch(getEmptySerialNo({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 3) {
            const res = await dispatch(getCgstNotEqualToSgst());
            console.log('res', res);
            setData(res);
         }
         if (tabId === 4) {
            const res = await dispatch(getDupItem());
            console.log('res', res);
            setData(res);
         }
         if (tabId === 5) {
            const res = await dispatch(getDupSerialNoINTran({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 6) {
            const res = await dispatch(getExtraLedger({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 7) {
            const res = await dispatch(getIssueDateLessThenPOrRDate({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 8) {
            const res = await dispatch(
               getLDWithOutCorresponingLIOrHeader({ companyId: user?.loginhistory?.companyId }),
            );
            console.log('res', res);
            setData(res);
         }
         if (tabId === 9) {
            const res = await dispatch(getPRDateLessThenPDate({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 10) {
            const res = await dispatch(
               getPWithPartyDatePartyBillNoDifference({ companyId: user?.loginhistory?.companyId }),
            );
            console.log('res', res);
            setData(res);
         }
         if (tabId === 11) {
            const res = await dispatch(getPRRateNotSameWithPRate({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 12) {
            const res = await dispatch(getSDateLessThanPDate({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 13) {
            const res = await dispatch(getSRDateLessThanSDate({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 14) {
            const res = await dispatch(getSameSerialNoWithDifferenetItem({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 15) {
            const res = await dispatch(getSerialNoSoldWithoutP({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 16) {
            const res = await dispatch(getSerialNoWithNegativeStock({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 17) {
            const res = await dispatch(getSerialNoWithStock({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 18) {
            const res = await dispatch(getTranWithSerialNoWithoutID({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 19) {
            const res = await dispatch(getTranWithMissingAccount({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 20) {
            const res = await dispatch(getTranWithMissingItem({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 21) {
            const res = await dispatch(getTranWithMissingTransport({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 22) {
            // const res = await dispatch(getWithoutLedger({ companyId: user?.loginhistory?.companyId }));
            // console.log("res", res);
            // setData(res);
            setData(null);
         }
         if (tabId === 23) {
            const res = await dispatch(getWrongSerialNoDueToLossOfInConn({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 24) {
            const res = await dispatch(getOverAdju({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 25) {
            const res = await dispatch(getLINotEqualLD({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 26) {
            const res = await dispatch(getBalanceDifferenceInLedger({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 27) {
            const res = await dispatch(getIncompleteLedgerEntries({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 28) {
            const res = await dispatch(getDuplicateLedgerForSameAccount({ companyId: user?.loginhistory?.companyId }));
            console.log('res', res);
            setData(res);
         }
         if (tabId === 29) {
            const res = await dispatch(
               getItems({
                  companyId: user?.loginhistory?.companyId,
                  ...(isItem && { companyIds: Number(user?.loginhistory?.companyId) }),
                  status: true,
                  page: 1,
                  sortBy: 'name',
                  sortOrder: 'asc',
                  ...filterOptions,
               }),
            );
            console.log('res', res);
            setData(res);
         }
      } catch (err) {
         setError('Failed to fetch data. Please try again.');
         setActiveTab(null);
      } finally {
         setLoading(false);
      }
   };

   const handleSubTabChange = async (type) => {
      console.log('tabId', type, typeof type);
      setSubActiveTab(type);
      setLoading(true);

      try {
         const res = await dispatch(getWithoutLedger({ companyId: user?.loginhistory?.companyId, type: type }));
         console.log('res', res);
         setData(res);
      } catch (err) {
         setError('Failed to fetch data. Please try again.');
         setActiveTab(null);
      } finally {
         setLoading(false);
      }
   };

   const handleClose = async () => {
      setData(null);
      setActiveTab(null);
      setSubActiveTab(null);
      setEnhanceStatus(null);
      setEnhanceProgress(0);
      onClose();
   };

   const handleResolve = async () => {
      if (activeTab === 6) {
         await dispatch(deleteLedgerEntries());
         handleTabChange(activeTab);
      }
   };

   const handleAutoEnhance = async () => {
      if (activeTab !== 29) return;

      setEnhancing(true);
      setEnhanceProgress(0);
      setEnhanceStatus(null);

      // Simulate progress
      const progressInterval = setInterval(() => {
         setEnhanceProgress((prev) => {
            if (prev >= 100) {
               clearInterval(progressInterval);
               return prev;
            }
            return prev + 2; // Slower progress for better visibility
         });
      }, 200); // Update every 200ms

      try {
         const res = await dispatch(
            getAutoEnhance({
               companyId: user?.loginhistory?.companyId,
               status: true,
               ...filterOptions,
            }),
         );

         clearInterval(progressInterval);
         setEnhanceProgress(100);

         console.log('Auto Enhance Response:', res);

         if (res && res.success) {
            setEnhanceStatus({
               success: true,
               message: res.message || 'Items enhanced successfully!',
               enhancedCount: res.enhancedCount || 0,
               failedCount: res.failedCount || 0,
            });

            toast({
               title: 'Enhancement Successful',
               description: `${res.enhancedCount || 0} items were enhanced successfully.`,
               status: 'success',
               duration: 5000,
               isClosable: true,
            });

            // Refresh data after successful enhancement
            setTimeout(() => {
               handleTabChange(29);
            }, 1000);
         } else {
            setEnhanceStatus({
               success: false,
               message: res?.message || 'Enhancement failed. Please try again.',
            });

            toast({
               title: 'Enhancement Failed',
               description: res?.message || 'Something went wrong. Please try again.',
               status: 'error',
               duration: 5000,
               isClosable: true,
            });
         }
      } catch (err) {
         clearInterval(progressInterval);
         setEnhanceStatus({
            success: false,
            message: 'Failed to enhance items. Please try again.',
         });

         toast({
            title: 'Enhancement Error',
            description: 'Failed to enhance items. Please try again.',
            status: 'error',
            duration: 5000,
            isClosable: true,
         });
      } finally {
         setTimeout(() => {
            setEnhancing(false);
            setEnhanceProgress(0);
         }, 1000);
      }
   };

   useEffect(() => {
      setData(null);
      setActiveTab(null);
      setEnhanceStatus(null);
      setEnhanceProgress(0);
   }, [onClose]);

   return (
      <Modal isOpen={isOpen} onClose={handleClose} size="6xl" motionPreset="slideInBottom">
         <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(10px)" />
         <ModalContent m={4} borderRadius="2xl">
            <ModalHeader bgGradient="linear(to-r, blue.500, blue.600)" color="white" borderTopRadius="2xl" py={6}>
               <HStack spacing={3}>
                  <Icon as={Database} w={8} h={8} />
                  <Text fontSize="2xl" fontWeight="bold">
                     Check
                  </Text>
               </HStack>
            </ModalHeader>
            <ModalCloseButton color="white" size="lg" />

            <ModalBody p={0}>
               <Box bgGradient={bgGradient}>
                  {/* Tab Buttons */}
                  <Box
                     bg={cardBg}
                     borderBottom="2px"
                     borderColor={borderColor}
                     p={4}
                     position="sticky"
                     top={0}
                     zIndex={10}
                     display="flex"
                     alignItems="center"
                     justifyContent="space-between"
                     gap={2}>
                     <Flex gap={4} align="center" width="70%">
                        <Menu>
                           <MenuButton
                              as={Button}
                              rightIcon={<ChevronDownIcon />}
                              maxW="400px"
                              w="full"
                              textAlign="left"
                              bg={menuBg}
                              borderColor={border}
                              borderWidth="1px"
                              borderRadius="md"
                              fontWeight="500"
                              fontSize="14px"
                              color={textColor}
                              _hover={{
                                 borderColor: hoverBorderColor,
                                 boxShadow: '0 0 0 1px rgba(66, 153, 225, 0.5)',
                              }}
                              _active={{
                                 borderColor: activeBorderColor,
                                 boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.1)',
                              }}
                              transition="all 0.2s">
                              {tabs.find((tab) => tab.id === activeTab)?.label || 'Select an option'}
                           </MenuButton>

                           <MenuList
                              maxW="400px"
                              bg={menuBg}
                              borderColor={border}
                              borderRadius="md"
                              boxShadow="0 4px 12px rgba(0,0,0,0.15)"
                              py={2}
                              maxH="300px"
                              overflowY="auto">
                              {tabs.map((tab) => (
                                 <MenuItem
                                    key={tab.id}
                                    onClick={() => handleTabChange(tab.id)}
                                    bg={activeTab === tab.id ? activeItemBg : 'transparent'}
                                    color={activeTab === tab.id ? activeItemColor : textColor}
                                    fontWeight={activeTab === tab.id ? '600' : '500'}
                                    fontSize="14px"
                                    px={4}
                                    py={3}
                                    _hover={{
                                       bg: activeTab === tab.id ? activeItemBg : itemHoverBg,
                                    }}
                                    _focus={{
                                       bg: activeTab === tab.id ? activeItemBg : itemHoverBg,
                                    }}
                                    transition="all 0.15s">
                                    {tab.label}
                                 </MenuItem>
                              ))}
                           </MenuList>
                        </Menu>

                        {activeTab === 22 && (
                           <Menu>
                              <MenuButton
                                 as={Button}
                                 rightIcon={<ChevronDownIcon />}
                                 maxW="400px"
                                 w="full"
                                 textAlign="left"
                                 bg={menuBg}
                                 borderColor={border}
                                 borderWidth="1px"
                                 borderRadius="md"
                                 fontWeight="500"
                                 fontSize="14px"
                                 marginLeft={2}
                                 color={textColor}
                                 _hover={{
                                    borderColor: hoverBorderColor,
                                    boxShadow: '0 0 0 1px rgba(66, 153, 225, 0.5)',
                                 }}
                                 _active={{
                                    borderColor: activeBorderColor,
                                    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.1)',
                                 }}
                                 transition="all 0.2s">
                                 {subTabs.find((tab) => tab.id === subActiveTab)?.label || 'Select an option'}
                              </MenuButton>

                              <MenuList
                                 maxW="400px"
                                 bg={menuBg}
                                 borderColor={border}
                                 borderRadius="md"
                                 boxShadow="0 4px 12px rgba(0,0,0,0.15)"
                                 py={2}
                                 maxH="300px"
                                 overflowY="auto">
                                 {subTabs.map((tab) => (
                                    <MenuItem
                                       key={tab.id}
                                       onClick={() => handleSubTabChange(tab.id)}
                                       bg={subActiveTab === tab.id ? activeItemBg : 'transparent'}
                                       color={subActiveTab === tab.id ? activeItemColor : textColor}
                                       fontWeight={subActiveTab === tab.id ? '600' : '500'}
                                       fontSize="14px"
                                       px={4}
                                       py={3}
                                       _hover={{
                                          bg: subActiveTab === tab.id ? activeItemBg : itemHoverBg,
                                       }}
                                       _focus={{
                                          bg: subActiveTab === tab.id ? activeItemBg : itemHoverBg,
                                       }}
                                       transition="all 0.15s">
                                       {tab.label}
                                    </MenuItem>
                                 ))}
                              </MenuList>
                           </Menu>
                        )}
                        {activeTab === 29 && (
                           <Menu closeOnSelect={false}>
                              <MenuButton
                                 as={Button}
                                 rightIcon={<ChevronDownIcon />}
                                 maxW="230px"
                                 w="full"
                                 textAlign="left"
                                 bg={menuBg}
                                 borderColor={border}
                                 borderWidth="1px"
                                 borderRadius="md"
                                 fontWeight="500"
                                 fontSize="14px"
                                 marginLeft={2}
                                 color={textColor}
                                 _hover={{
                                    borderColor: hoverBorderColor,
                                    boxShadow: '0 0 0 1px rgba(66, 153, 225, 0.5)',
                                 }}
                                 _active={{
                                    borderColor: activeBorderColor,
                                    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.1)',
                                 }}
                                 transition="all 0.2s">
                                 Filter Options
                              </MenuButton>

                              <MenuList
                                 bg={menuBg}
                                 borderColor={border}
                                 borderRadius="md"
                                 boxShadow="0 4px 12px rgba(0,0,0,0.15)"
                                 py={2}
                                 px={2}
                                 maxW="250px"
                                 maxH="400px"
                                 overflowY="auto">
                                 <Text px={3} py={2} fontWeight="600" fontSize="sm" color={textColor}>
                                    Select Filters
                                 </Text>
                                 <Divider mb={2} />

                                 <VStack spacing={2} align="stretch" px={2}>
                                    <MenuItem
                                       onClick={(e) => {
                                          e.stopPropagation();
                                          handleFilterChange('notSeries');
                                       }}
                                       _hover={{ bg: itemHoverBg }}
                                       borderRadius="md">
                                       <Checkbox
                                          isChecked={filterOptions.notSeries}
                                          onChange={(e) => {
                                             e.stopPropagation();
                                             handleFilterChange('notSeries');
                                          }}
                                          colorScheme="blue"
                                          size="md"
                                          width="100%"
                                          py={2}
                                          px={1}>
                                          <Text fontSize="14px">Not Series</Text>
                                       </Checkbox>
                                    </MenuItem>

                                    <MenuItem
                                       onClick={(e) => {
                                          e.stopPropagation();
                                          handleFilterChange('notColor');
                                       }}
                                       _hover={{ bg: itemHoverBg }}
                                       borderRadius="md">
                                       <Checkbox
                                          isChecked={filterOptions.notColor}
                                          onChange={(e) => {
                                             e.stopPropagation();
                                             handleFilterChange('notColor');
                                          }}
                                          colorScheme="blue"
                                          size="md"
                                          width="100%"
                                          py={2}
                                          px={1}>
                                          <Text fontSize="14px">Not Color</Text>
                                       </Checkbox>
                                    </MenuItem>

                                    <MenuItem
                                       onClick={(e) => {
                                          e.stopPropagation();
                                          handleFilterChange('notCategory');
                                       }}
                                       _hover={{ bg: itemHoverBg }}
                                       borderRadius="md">
                                       <Checkbox
                                          isChecked={filterOptions.notCategory}
                                          onChange={(e) => {
                                             e.stopPropagation();
                                             handleFilterChange('notCategory');
                                          }}
                                          colorScheme="blue"
                                          size="md"
                                          width="100%"
                                          py={2}
                                          px={1}>
                                          <Text fontSize="14px">Not Category</Text>
                                       </Checkbox>
                                    </MenuItem>

                                    <MenuItem
                                       onClick={(e) => {
                                          e.stopPropagation();
                                          handleFilterChange('notRam');
                                       }}
                                       _hover={{ bg: itemHoverBg }}
                                       borderRadius="md">
                                       <Checkbox
                                          isChecked={filterOptions.notRam}
                                          onChange={(e) => {
                                             e.stopPropagation();
                                             handleFilterChange('notRam');
                                          }}
                                          colorScheme="blue"
                                          size="md"
                                          width="100%"
                                          py={2}
                                          px={1}>
                                          <Text fontSize="14px">Not RAM</Text>
                                       </Checkbox>
                                    </MenuItem>

                                    <MenuItem
                                       onClick={(e) => {
                                          e.stopPropagation();
                                          handleFilterChange('notStorage');
                                       }}
                                       _hover={{ bg: itemHoverBg }}
                                       borderRadius="md">
                                       <Checkbox
                                          isChecked={filterOptions.notStorage}
                                          onChange={(e) => {
                                             e.stopPropagation();
                                             handleFilterChange('notStorage');
                                          }}
                                          colorScheme="blue"
                                          size="md"
                                          width="100%"
                                          py={2}
                                          px={1}>
                                          <Text fontSize="14px">Not Storage</Text>
                                       </Checkbox>
                                    </MenuItem>
                                 </VStack>

                                 <Box px={3} pt={3}>
                                    <Button
                                       size="sm"
                                       colorScheme="blue"
                                       width="100%"
                                       onClick={() => {
                                          // Refresh data with updated filters
                                          handleTabChange(29);
                                       }}
                                       isDisabled={loading}>
                                       Apply Filters
                                    </Button>
                                 </Box>
                              </MenuList>
                           </Menu>
                        )}
                     </Flex>

                     <Text fontSize="14px" fontWeight="600" color={textColor} whiteSpace="nowrap">
                        Total Count: {data?.length || 0}
                     </Text>
                  </Box>

                  {/* Content Area */}
                  <Box p="15px" overflow="auto">
                     {loading ? (
                        <VStack spacing={4} justify="center" height="400px">
                           <Spinner size="xl" color="blue.500" thickness="4px" speed="0.65s" />
                           <Text fontSize="lg" color="gray.600">
                              Loading data...
                           </Text>
                        </VStack>
                     ) : !activeTab || (activeTab === 22 && !subActiveTab) ? (
                        <VStack spacing={4} justify="center" height="400px">
                           <Text fontSize="xl" fontWeight="semibold" color="gray.700">
                              Select an Option
                           </Text>
                           <Text fontSize="md" color="gray.500" textAlign="center">
                              Please choose an option from the option list above to view data
                           </Text>
                        </VStack>
                     ) : data && data.length > 0 ? (
                        <VStack spacing={6} align="stretch" height="auto" maxH="500px">
                           {activeTab === 29 && enhancing && (
                              <Box display="flex" justifyContent="center" alignItems="center" mb={4}>
                                 <Box
                                    width="80%"
                                    bg={cardBg}
                                    borderRadius="lg"
                                    p={3}
                                    border="1px"
                                    borderColor={borderColor}
                                    boxShadow="md">
                                    <VStack spacing={4} align="center">
                                       <HStack spacing={3}>
                                          <Icon as={Wand2} w={6} h={6} color="purple.500" />
                                          <Text fontSize="lg" fontWeight="bold" color="purple.600">
                                             Enhancing Items...
                                          </Text>
                                       </HStack>

                                       <Progress
                                          value={enhanceProgress}
                                          colorScheme="purple"
                                          size="md"
                                          width="100%"
                                          borderRadius="full"
                                          height="10px"
                                       />

                                       <Text fontSize="md" fontWeight="medium" color="gray.600">
                                          {enhanceProgress}% Complete
                                       </Text>
                                    </VStack>
                                 </Box>
                              </Box>
                           )}
                           {/* Summary Cards */}
                           {/* <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4}>
                              <GridItem>
                                 <Box
                                    bgGradient="linear(to-br, blue.50, blue.100)"
                                    borderRadius="xl"
                                    p={6}
                                    border="1px"
                                    borderColor="blue.200"
                                    boxShadow="sm"
                                 >
                                    <Flex justify="space-between" align="center">
                                       <Box>
                                          <Text fontSize="sm" color="blue.600" fontWeight="medium">Total Records</Text>
                                          <Text fontSize="3xl" fontWeight="bold" color="blue.900" mt={1}>
                                             {data.records}
                                          </Text>
                                       </Box>
                                       <Icon as={CheckCircle} w={10} h={10} color="blue.600" />
                                    </Flex>
                                 </Box>
                              </GridItem>

                              <GridItem>
                                 <Box
                                    bgGradient="linear(to-br, green.50, green.100)"
                                    borderRadius="xl"
                                    p={6}
                                    border="1px"
                                    borderColor="green.200"
                                    boxShadow="sm"
                                 >
                                    <Flex justify="space-between" align="center">
                                       <Box>
                                          <Text fontSize="sm" color="green.600" fontWeight="medium">Status</Text>
                                          <Text fontSize="2xl" fontWeight="bold" color="green.900" mt={1}>
                                             {data.status}
                                          </Text>
                                       </Box>
                                       <Icon as={Database} w={10} h={10} color="green.600" />
                                    </Flex>
                                 </Box>
                              </GridItem>

                              <GridItem>
                                 <Box
                                    bgGradient="linear(to-br, purple.50, purple.100)"
                                    borderRadius="xl"
                                    p={6}
                                    border="1px"
                                    borderColor="purple.200"
                                    boxShadow="sm"
                                 >
                                    <Flex justify="space-between" align="center">
                                       <Box>
                                          <Text fontSize="sm" color="purple.600" fontWeight="medium">Last Updated</Text>
                                          <Text fontSize="sm" fontWeight="semibold" color="purple.900" mt={1}>
                                             {new Date(data.timestamp).toLocaleTimeString()}
                                          </Text>
                                       </Box>
                                       <Icon as={RefreshCw} w={10} h={10} color="purple.600" />
                                    </Flex>
                                 </Box>
                              </GridItem>
                           </Grid> */}

                           {/* Data Table */}
                           <Box
                              bg={cardBg}
                              borderRadius="xl"
                              border="1px"
                              borderColor={borderColor}
                              overflow="auto"
                              boxShadow="md">
                              <Box height="auto">
                                 <Table variant="simple">
                                    <Thead>
                                       <Tr>
                                          {activeTab === 1 && (
                                             <>

                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Created Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Mobile
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Email
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Gst NO
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Actions
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 2 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc no
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   source
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 3 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc no
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   source
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 4 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Color Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Series Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Ram
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Storage
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   MRP
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Created Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Created By
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 5 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc no
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Serial No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Duplicate Count
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   source
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 6 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 7 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Purchase Party Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Purchase Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxaable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 8 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Serial No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Entry Type
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Orphan Type
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 9 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Purchase Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Purchase Party Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 10 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Party No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Party Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Remarks
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 11 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Serial No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Party No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Purchase Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Party Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Return Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Return Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Purchase Rate
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Purchase Return Rate
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 12 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Sales Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Purchase Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Purchase Party Date
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 13 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Sales Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 14 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Serial No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item Count
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Issue Type
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 15 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Serial No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   First Sales Doc
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   First Sales Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Issue Type
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 16 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Serial No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   First In Stock
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   First out Stock
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Total In Stock
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Total out Stock
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Current Stock
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Issue Type
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 17 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Serial No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Current Stock
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Total Transaction
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   First Transaction
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Last Transaction
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Issue Type
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 18 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 19 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 20 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 21 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 22 && subActiveTab === 'SALES_WITHOUT_LEDGER' && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 22 && subActiveTab === 'PURCHASE_WITHOUT_LEDGER' && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Party No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Party Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 22 && subActiveTab === 'SALES_RETURN_WITHOUT_LEDGER' && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 22 && subActiveTab === 'PURCHASE_RETURN_WITHOUT_LEDGER' && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 22 && subActiveTab === 'VOUCHER_WITHOUT_LEDGER' && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   TXN Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Amount
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 23 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Serial No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Actions
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 24 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Taxable Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Pending Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Total Adjustment Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Status
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Entry Type
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 25 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   lineItem Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   lineDetail Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Serial No
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 26 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Amount
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Net Amount
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 27 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Entry Type
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Count
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Action
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 28 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Doc No
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Daybook Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Account Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Count
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Action
                                                </Th>
                                             </>
                                          )}
                                          {activeTab === 29 && (
                                             <>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Transaction Date
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Item Name
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Group
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Bal Qty 1
                                                </Th>
                                                <Th textTransform="uppercase" fontSize="xs" fontWeight="semibold">
                                                   Action
                                                </Th>
                                             </>
                                          )}
                                       </Tr>
                                    </Thead>
                                    <Tbody>
                                       {data &&
                                          data.length > 0 &&
                                          data.map((data) => (
                                             <Tr key={data.id} _hover={{ bg: hoverBg }} transition="all 0.2s">
                                                {activeTab === 1 && (
                                                   <>
                                                      <Td>{new Date(data.createdAt).toLocaleDateString('en-GB')}</Td>
                                                      <Td fontWeight="semibold">{data.name}</Td>
                                                      <Td>{data.mobile ?? '-'}</Td>
                                                      <Td>{data.email && data.email !== '' ? data.email : '-'}</Td>
                                                      <Td fontWeight="semibold">{data.gstRegNo}</Td>
                                                      <Td fontWeight="semibold">{data.actions}</Td>
                                                      {/* <Td>
                                                      <Badge
                                                         colorScheme={data.status === 'Completed' ? 'green' : 'yellow'}
                                                         px={3}
                                                         py={1}
                                                         borderRadius="full"
                                                         fontSize="xs"
                                                      >
                                                         {data.status}
                                                      </Badge>
                                                   </Td> */}
                                                   </>
                                                )}
                                                {activeTab === 2 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.item_name}</Td>
                                                      <Td fontWeight="semibold">{data.source}</Td>
                                                   </>
                                                )}
                                                {activeTab === 3 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>{data.item_name}</Td>
                                                      <Td fontWeight="semibold">{data.source}</Td>
                                                   </>
                                                )}
                                                {activeTab === 4 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.name}</Td>
                                                      <Td>{data.color_name ?? '-'}</Td>
                                                      <Td>{data.series_name ?? '-'}</Td>
                                                      <Td>{data.ram}</Td>
                                                      <Td>{data.storage}</Td>
                                                      <Td>{data.mrp}</Td>
                                                      <Td>{new Date(data.createdAt).toLocaleDateString('en-GB')}</Td>
                                                      <Td fontWeight="semibold">{data.created_by_name}</Td>
                                                   </>
                                                )}
                                                {activeTab === 5 && (
                                                   <>
                                                      <Td>{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.account_name}</Td>
                                                      <Td>{data.item_name}</Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            {data.serialNo}
                                                         </Badge>
                                                      </Td>
                                                      {/* <Td>{data.serialNo}</Td> */}
                                                      <Td>{data.duplicate_count}</Td>
                                                      <Td fontWeight="semibold">{data.transaction_type}</Td>
                                                   </>
                                                )}
                                                {activeTab === 6 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docNumber}</Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.account_name}</Td>
                                                      <Td>{data.amount}</Td>
                                                      <Td>{new Date(data.txnDate).toLocaleDateString('en-GB')}</Td>
                                                   </>
                                                )}
                                                {activeTab === 7 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>
                                                         {new Date(data.purchase_party_date).toLocaleDateString(
                                                            'en-GB',
                                                         )}
                                                      </Td>
                                                      <Td>
                                                         {new Date(data.purchase_transaction_date).toLocaleDateString(
                                                            'en-GB',
                                                         )}
                                                      </Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>{data.taxableAmount}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                   </>
                                                )}
                                                {activeTab === 8 && (
                                                   <>
                                                      <Td>{data.item_name}</Td>
                                                      <Td fontWeight="semibold">{data.serialNo}</Td>
                                                      <Td fontWeight="semibold">{data.source}</Td>
                                                      <Td>{data.orphan_type}</Td>
                                                   </>
                                                )}
                                                {activeTab === 9 && (
                                                   <>
                                                      <Td>{data.docno}</Td>
                                                      <Td fontWeight="semibold">{new Date(data.transactionAt).toLocaleDateString('en-GB')}</Td>
                                                      <Td>{new Date(data.purchase_transaction_date).toLocaleDateString('en-GB')}</Td>
                                                      <Td>{new Date(data.purchase_party_date).toLocaleDateString('en-GB')}</Td>
                                                      <Td fontWeight="semibold">{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                      <Td fontWeight="semibold">{data.taxableAmount}</Td>
                                                   </>
                                                )}
                                                {activeTab === 10 && (
                                                   <>
                                                      <Td
                                                         fontWeight={
                                                            data.docno !== data.partyNo ? 'semibold' : 'normal'
                                                         }>
                                                         {data.docno}
                                                      </Td>
                                                      <Td
                                                         fontWeight={
                                                            data.docno !== data.partyNo ? 'semibold' : 'normal'
                                                         }>
                                                         {data.partyNo}
                                                      </Td>
                                                      <Td
                                                         fontWeight={
                                                            data.partyDate !== data.transactionAt
                                                               ? 'semibold'
                                                               : 'normal'
                                                         }>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td
                                                         fontWeight={
                                                            data.partyDate !== data.transactionAt
                                                               ? 'semibold'
                                                               : 'normal'
                                                         }>
                                                         {new Date(data.partyDate).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>₹{data.taxableAmount}</Td>
                                                      <Td>₹{data.netAmount}</Td>
                                                      <Td>{data.remarks}</Td>
                                                   </>
                                                )}
                                                {activeTab === 11 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.serialNo}</Td>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td fontWeight="semibold">{data.partyNo}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{new Date(data.partyDate).toLocaleDateString('en-GB')}</Td>
                                                      <Td fontWeight="semibold">{data.return_doc_no}</Td>
                                                      <Td>{new Date(data.return_date).toLocaleDateString('en-GB')}</Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            ₹ {data.purchase_rate}
                                                         </Badge>
                                                      </Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            ₹ {data.purchase_return_rate}
                                                         </Badge>
                                                      </Td>
                                                      <Td>₹{data.taxableAmount}</Td>
                                                      <Td>₹{data.netAmount}</Td>
                                                   </>
                                                )}
                                                {activeTab === 12 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>{data.taxableAmount}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                         </Badge>
                                                      </Td>
                                                      c
                                                      <Td>
                                                         {new Date(data.purchase_party_date).toLocaleDateString(
                                                            'en-GB',
                                                         )}
                                                      </Td>
                                                   </>
                                                )}
                                                {activeTab === 13 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>{data.taxableAmount}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            {new Date(data.sales_transaction_date).toLocaleDateString(
                                                               'en-GB',
                                                            )}
                                                         </Badge>
                                                      </Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                         </Badge>
                                                      </Td>
                                                   </>
                                                )}
                                                {activeTab === 14 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.serialNo}</Td>
                                                      <Td>
                                                         {data.item_names.split('|').map((item, index) => (
                                                            <div key={index}>
                                                               {item.trim()} {', '}
                                                            </div>
                                                         ))}
                                                      </Td>
                                                      <Td>{data.item_count}</Td>
                                                      <Td>{data.issue_type}</Td>
                                                   </>
                                                )}
                                                {activeTab === 15 && (
                                                   <>
                                                      <Td>{data.account_name}</Td>
                                                      <Td>{data.item_name}</Td>
                                                      <Td fontWeight="semibold">{data.serialNo}</Td>
                                                      <Td>{data.first_doc_number}</Td>
                                                      <Td>
                                                         {new Date(data.first_out_date).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.issue_type}</Td>
                                                   </>
                                                )}
                                                {activeTab === 16 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.serialNo}</Td>
                                                      <Td>{data.item_name}</Td>
                                                      <Td>
                                                         {new Date(data.first_in_date).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>
                                                         {new Date(data.first_out_date).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.total_in}</Td>
                                                      <Td>{data.total_out}</Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            {data.current_stock}
                                                         </Badge>
                                                      </Td>
                                                      <Td>{data.issue_type}</Td>
                                                   </>
                                                )}
                                                {activeTab === 17 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.serialNo}</Td>
                                                      <Td>{data.item_name}</Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            {data.current_stock}
                                                         </Badge>
                                                      </Td>
                                                      <Td>{data.total_transactions}</Td>
                                                      <Td>
                                                         {new Date(data.first_transaction_date).toLocaleDateString(
                                                            'en-GB',
                                                         )}
                                                      </Td>
                                                      <Td>
                                                         {new Date(data.last_transaction_date).toLocaleDateString(
                                                            'en-GB',
                                                         )}
                                                      </Td>
                                                      <Td>{data.issue_type}</Td>
                                                   </>
                                                )}
                                                {activeTab === 18 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>{data.item_name}</Td>
                                                      <Td>{data.taxableAmount}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                   </>
                                                )}
                                                {activeTab === 19 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.daybook_name}</Td>
                                                   </>
                                                )}
                                                {activeTab === 20 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                   </>
                                                )}
                                                {activeTab === 21 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>{data.taxableAmount}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                   </>
                                                )}
                                                {activeTab === 22 && subActiveTab === 'SALES_WITHOUT_LEDGER' && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>{data.taxableAmount}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                   </>
                                                )}
                                                {activeTab === 22 && subActiveTab === 'PURCHASE_WITHOUT_LEDGER' && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td fontWeight="semibold">{data.partyNo}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{new Date(data.partyDate).toLocaleDateString('en-GB')}</Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>{data.taxableAmount}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                   </>
                                                )}
                                                {activeTab === 22 && subActiveTab === 'SALES_RETURN_WITHOUT_LEDGER' && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>{data.taxableAmount}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                   </>
                                                )}
                                                {activeTab === 22 && subActiveTab === 'PURCHASE_RETURN_WITHOUT_LEDGER' && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>{data.taxableAmount}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                   </>
                                                )}
                                                {activeTab === 22 && subActiveTab === 'VOUCHER_WITHOUT_LEDGER' && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docNumber}</Td>
                                                      <Td>{new Date(data.txnDate).toLocaleDateString('en-GB')}</Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td>{data.amount}</Td>
                                                   </>
                                                )}
                                                {activeTab === 23 && (
                                                   <>
                                                      <Td>{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party_name}</Td>
                                                      <Td fontWeight="semibold">{data.serialNo ?? '-'}</Td>
                                                      <Td>{data.taxableAmount ?? '-'}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                      <Td fontWeight="semibold">{data.actions}</Td>
                                                   </>
                                                )}
                                                {activeTab === 24 && (
                                                   <>
                                                      <Td>{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.daybookName}</Td>
                                                      <Td>{data.accountName}</Td>
                                                      <Td>{data.taxableAmount}</Td>
                                                      <Td>{data.PendingAmt}</Td>
                                                      <Td>{data.TotalAdjAmt}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                      <Td fontWeight="semibold">{data.PendingStatus}</Td>
                                                      <Td fontWeight="semibold">{data.transactionType}</Td>
                                                   </>
                                                )}
                                                {activeTab === 25 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.daybook_name}</Td>
                                                      <Td>{data.party}</Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            {data.line_item_name}
                                                         </Badge>
                                                      </Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            {data.detail_item_name}
                                                         </Badge>
                                                      </Td>
                                                      <Td>{data.serialNo}</Td>
                                                   </>
                                                )}
                                                {activeTab === 26 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docno}</Td>
                                                      <Td>
                                                         {new Date(data.transactionAt).toLocaleDateString('en-GB')}
                                                      </Td>
                                                      <Td>{data.amount}</Td>
                                                      <Td>{data.netAmount}</Td>
                                                   </>
                                                )}
                                                {activeTab === 27 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docNumber}</Td>
                                                      <Td>{new Date(data.txnDate).toLocaleDateString('en-GB')}</Td>
                                                      <Td>{data.dbk_name}</Td>
                                                      <Td>{data.party}</Td>
                                                      <Td>{data.txn_source}</Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            {data.cnt}
                                                         </Badge>
                                                      </Td>
                                                      <Td>{data.action}</Td>
                                                   </>
                                                )}
                                                {activeTab === 28 && (
                                                   <>
                                                      <Td fontWeight="semibold">{data.docNumber}</Td>
                                                      <Td>{new Date(data.txnDate).toLocaleDateString('en-GB')}</Td>
                                                      <Td>{data.dbk_name}</Td>
                                                      <Td>{data.party}</Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            {data.cnt}
                                                         </Badge>
                                                      </Td>
                                                      <Td>{data.action}</Td>
                                                   </>
                                                )}
                                                {activeTab === 29 && (
                                                   <>
                                                      <Td>{new Date(data.createdAt).toLocaleDateString('en-GB')}</Td>
                                                      <Td>{data.name}</Td>
                                                      <Td>{data.itemGroupName}</Td>
                                                      <Td>
                                                         <Badge
                                                            colorScheme={'yellow'}
                                                            px={3}
                                                            py={1}
                                                            borderRadius="full"
                                                            fontSize="medium">
                                                            {data.balancequantity1}
                                                         </Badge>
                                                      </Td>
                                                      <Td>{data.action}</Td>
                                                   </>
                                                )}
                                             </Tr>
                                          ))}
                                    </Tbody>
                                 </Table>
                              </Box>
                           </Box>
                        </VStack>
                     ) : (
                        <VStack spacing={4} justify="center" h="400px">
                           <Icon as={InfoIcon} w={10} h={10} color="gray.400" />
                           <Text fontSize="xl" fontWeight="semibold" color="gray.700">
                              No Data Available
                           </Text>
                           <Text fontSize="md" color="gray.500" textAlign="center">
                              Please choose another option from the list above to view data.
                           </Text>
                        </VStack>
                     )}
                  </Box>
               </Box>
            </ModalBody>
            <ModalFooter>
               <Box
                  bg={cardBg}
                  borderTop="2px"
                  borderColor={borderColor}
                  // px={0}
                  pt={4}
                  // py={0}
                  position="sticky"
                  bottom={2}
                  width="100%">
                  <Flex justify="space-between" align="center">
                     <Button
                        leftIcon={<Icon as={RefreshCw} />}
                        variant="outline"
                        colorScheme="gray"
                        onClick={() => {
                           if (activeTab === 22) {
                              handleSubTabChange(subActiveTab);
                           } else {
                              handleTabChange(activeTab);
                           }
                        }}>
                        Refresh
                     </Button>
                     {activeTab === 6 && (
                        <Button
                           colorScheme="blue"
                           boxShadow="md"
                           onClick={() => {
                              if (activeTab === 6) {
                                 handleResolve();
                              }
                           }}>
                           Resolve
                        </Button>
                     )}
                     {activeTab === 29 && (
                        <Button
                           colorScheme="purple"
                           boxShadow="lg"
                           leftIcon={<Icon as={Wand2} />}
                           onClick={handleAutoEnhance}
                           isLoading={enhancing}
                           loadingText="Enhancing..."
                           disabled={enhancing || loading}
                           size="lg"
                           px={8}
                           bgGradient="linear(to-r, purple.500, pink.500)"
                           color="white"
                           _hover={{
                              bgGradient: 'linear(to-r, purple.600, pink.600)',
                              transform: 'translateY(-2px)',
                              boxShadow: 'xl',
                           }}
                           _active={{
                              transform: 'translateY(0)',
                           }}
                           transition="all 0.3s">
                           Auto Enhance Items
                        </Button>
                     )}
                  </Flex>
               </Box>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default OSCheck;
